import { isEqual } from 'lodash'

import { DeserializedSavedFilter } from 'api/AccountActivityAPI/types'
import { FilterGroup } from 'utils/filters'

interface FilterHasChangedArgs {
  filterGroups: FilterGroup[]
  filterName: string
  assignedTeams: number[]
  assignedUsers: number[]
  hasDesktopNotifications: boolean
  hasEmailNotifications: boolean
  savedFilter?: DeserializedSavedFilter
  isAdmin?: boolean
}

/**
 * Returns true if any of the filter groups, filter name, or org settings have changed
 */
export const filterHasChanged = ({
  filterGroups,
  filterName,
  assignedTeams,
  assignedUsers,
  hasDesktopNotifications,
  hasEmailNotifications,
  savedFilter,
  isAdmin
}: FilterHasChangedArgs) => {
  if (!savedFilter) {
    return true
  }

  // Compare the filter groups
  const filterGroupsChanged = !isEqual(filterGroups, savedFilter.body.filterGroups)
  // Compare the filter name
  const filterNameChanged = savedFilter.name !== filterName
  // Compare the org settings for assigned teams, assigned users, desktop notifications, and email notifications
  const assignedTeamsChanged = !isEqual(savedFilter?.orgSettings?.teamsWithFilter, assignedTeams)
  const assignedUsersChanged = !isEqual(savedFilter?.orgSettings?.usersWithFilter, assignedUsers)
  const desktopNotificationsChanged = !isEqual(
    savedFilter?.orgSettings?.pushNotificationsTurnedOn,
    hasDesktopNotifications
  )
  const emailNotificationsChanged = !isEqual(
    savedFilter?.orgSettings?.digestNotificationsTurnedOn,
    hasEmailNotifications
  )

  const orgSettingsChanged =
    assignedTeamsChanged ||
    assignedUsersChanged ||
    desktopNotificationsChanged ||
    emailNotificationsChanged
  //  Return true if any of the filter groups, filter name, or (admins only) org settings have changed
  return filterGroupsChanged || filterNameChanged || (isAdmin ? orgSettingsChanged : false)
}
